import { FETCH_ERROR} from './actions.type'
import {SET_ERRORS } from './mutations.type'

const state = {
	errors: [],
	isLoading: false,
	fonMapsQuery: ''
}

const getters = {
	errors() {
		return state.errors
	}
}
const actions = {
	[FETCH_ERROR] (context, mesage) { // masage должен быть обект {title:"", text:"", variant:"'это стили бутстрапа'"}
		context.commit(SET_ERRORS, mesage)
	}
}
const mutations = {
	 [SET_ERRORS] (state, errors) {
		state.errors.push(errors)
	 }
}
export default {
	state,
	getters,
	actions,
	mutations
}


// WEBPACK FOOTER //
// ./src/store/errors.module.js